import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injectable, APP_INITIALIZER } from '@angular/core';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CircleTimerModule } from './modules/circle-timer/src/public-api';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SignInComponent } from './component/sign-in/sign-in.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ForgotPasswordComponent } from './component/forgot-password/forgot-password.component';
import { RangePipe } from './pipe/range-pipe/range.pipe';
import { FilterPipe } from './pipe/list-filter-pipe/list-filter-pipe';
import { FilterByKeyPipe } from './pipe/list-filterbykey-pipe/list-filterbykey-pipe';
import { DispatchDashboardComponent } from './component/dashboard/dashboard/dashboard.component';
import { AgmCoreModule, LAZY_MAPS_API_CONFIG, LazyMapsAPILoaderConfigLiteral } from '@agm/core';
import { StaffMainComponent } from './component/staffs/staff-main/staff-main.component';
import { StaffsCreateComponent } from './component/staffs/staffs-create/staffs-create.component';
import { TokenInterceptorService } from './service/token-interceptor-service/token-interceptor.service';
import { EditUserProfileComponent } from './component/user profile/edit-user-profile/edit-user-profile.component';
import { AuthorizationGuard } from './service/auth-guard/authorization-guard.service';
// we are using this in edit profile for all time zone list
import { AutocompleteComponent } from './component/common-components/goolge-places-selecters/google-places.component';
// import { TripsHistoryComponent } from './component/dispatch-center/trips-history/trips-history.component';
import { DriverListComponent } from './component/drivers/driver-list/driver-list.component';
import { RolePipe } from './pipe/role-value-filter/role.pipe';
import { AccountStatusPipe } from './pipe/account-status-value-filter/account-status.pipe';
import { CreateDriverComponent } from './component/drivers/create-driver/create-driver.component';
import { DriverProfileDashboardComponent } from './component/drivers/driver-profile-dashboard/driver-profile-dashboard.component';
import { ImageModalComponent } from './modals/image-modal/image-modal.component';
import { CamelCasePipe } from './pipe/camelcase.filter/camelcase.filter.pipe';
import { CorporateuserComponent } from './component/corporate-user/corporate-user-list/corporate-user.component';
import { CorporateAddUserComponent } from './component/corporate-user/corporate-add-user/corporate-add-user.component';
import { FleetListComponent } from './component/fleet/fleet-list/fleet-list.component';
import { CreateFleetComponent } from './component/fleet/create-fleet/create-fleet.component';
import { DriverDistributionsComponent } from './component/driver-distributions/driver-distributions-list/driver-distributions.component';
// tslint:disable-next-line: max-line-length
import { DriverDistributionsCreateComponent } from './component/driver-distributions/driver-distributions-create/driver-distributions-create.component';
import { DriverAlertComponent } from './component/driver-alert/driver-alert/driver-alert.component';
import { HelpingMaterialListComponent } from './component/helping-material/helping-material-list/helping-material-list.component';
import { UrlSafePipe } from './pipe/url-safe-pipe/url-safe.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ParseTripsComponent } from './component/broker-parser/parse-trips/parse-trips.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
// import { PlannerEffects } from './ngrx/store/effects/planner-effects';
import { UnassignedComponent } from './component/assigned-trips/unassigned/unassigned.component';
import { VerifiedTripLogsComponent } from './component/billing/verified-trip-logs/verified-trip-logs.component';
import { NewTripComponent } from './component/assigned-trips/new-trip/new-trip.component';
import { CustomPlaceDirective } from './directives/custom-places-directive/custom-place.directive';
import { GooglePlaceDirective } from './directives/google-places-directive/google-place.directive';
import { NemtStatisticsComponent } from './component/kpis/nemt-statistics/nemt-statistics.component';
import { NemtReportComponent } from './component/kpis/nemt-report/nemt-report.component';

import { DynamicFareListComponent } from './component/dynamic-fare/dynamic-fare-list/dynamic-fare-list.component';
import { DynamicFareAddComponent } from './component/dynamic-fare/dynamic-fare-add/dynamic-fare-add.component';
import { SocketIoModule, SocketIoConfig, Socket } from 'ngx-socket-io';
import { urls } from './utils/url-utils';
import { SocketService } from './service/socket-service/socket-service.service';
import { AgmOverlays } from 'agm-overlays';
import { EarningsComponent } from './component/reports/earnings/earnings.component';
import { TripFilterPipe } from './pipe/trip-list-filter-pipe/trip-filter.pipe';
import { TripAssignModalComponent } from './modals/trip-assign-modal/trip-assign-modal.component';
import { TimeFormatDirective } from './directives/time-format-directive/time-format.directive';
import { CompanyNoteModalComponent } from './modals/company-note-modal/company-note-modal.component';
import { CancelTripModalComponent } from './modals/cancel-trip-modal/cancel-trip-modal.component';
import { TimePipe } from './pipe/time-pipe/time.pipe';
import { AgmDirectionModule } from 'agm-direction';
import { TripDetailDialogComponent } from './component/common-components/trip-detail-dialog/trip-detail-dialog.component';

import { SignaturePadModule } from 'angular2-signaturepad';
import { CommonAlertComponent } from './component/common-components/common-alert/common-alert.component';
import { DriverBreakdownComponent } from './component/kpis/driver-breakdown/driver-breakdown.component';
import { SweepTripsModalComponent } from './modals/sweep-trips-modal/sweep-trips-modal.component';
import { TimeagoModule } from 'ngx-timeago';
import { MySocketWrapper } from './service/socket-service/socket-wrapper';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule } from './modules/ngx-ui-loader/src/public-api';
import { DatePipe } from './pipe/date-pipe/date.pipe';
import { OwlModule } from 'ngx-owl-carousel';
import { NotificationDetailsComponent } from './notification/notification-details/notification-details.component';
import { ComplianceNotificationsComponent } from './component/compliance-notifications/compliance-notifications.component';
// import { AccidnetsListComponent } from './component/accidents/accidnets-list/accidnets-list.component';
// import { AddAccidentComponent } from './component/accidents/add-accident/add-accident.component';
import { HelpingMaterialPdfComponent } from './component/helping-material/helping-material-pdf/helping-material-pdf.component';
// import { AccidentDetailInTailwindFormComponent } from './component/accidents/accident-detail-in-tailwind-form/accident-detail-in-tailwind-form.component';
import { LogsComponent } from './component/offered-trips/logs/logs.component';
import { MemberListComponent } from './component/members/member-list/member-list.component';
import { CreateMemberComponent } from './component/members/create-member/create-member.component';
import { OutstandingComponent } from './component/assigned-trips/outstanding/outstanding.component';
import { DriverInvoicesComponent } from './component/drivers/driver-invoices/driver-invoices.component';
import { DirtRoadComponent } from './component/assigned-trips/dirt-road/dirt-road.component';
import { DriverTimelinesComponent } from './component/drivers/driver-timelines/driver-timelines.component';
import { TripDetailModelComponent } from './modals/trip-detail-model/trip-detail-model.component';
import { OutstandingTripsModalComponent } from './modals/outstanding-trips-modal/outstanding-trips-modal.component';
import { ZDatesComponent } from './component/page-not-found/z-dates.component';
import { SideNavComponent } from './component/shared/layout/side-nav/side-nav.component';
import { HeaderComponent } from './component/shared/layout/header/header.component';
import { StaffAttendanceComponent } from './component/staffs/staff-attendance/staff-attendance.component';
import { DriverEarningModalComponent } from './component/reports/earnings/driver-earning-modal/driver-earning-modal.component';
import { NotificationsSlideoutComponent } from './component/shared/slideouts/notifications-slideout/notifications-slideout.component';
import { DispatchInprogressTripsSlideoutComponent } from './component/shared/slideouts/dispatch-inprogress-trips-slideout/dispatch-inprogress-trips-slideout.component';
import { SortByDatePipe } from './pipe/sort-by-date/sort-by-date.pipe';
import { OutsideClickDirective } from './directives/outside-click-directive/outside-click.directive';
import { BrokerDropdownComponent } from './component/shared/broker-dropdown/broker-dropdown.component';
import { TripActionsDropdownComponent } from './component/shared/trip-actions-dropdown/trip-actions-dropdown.component';
import { ClockTimePipe } from './pipe/clock-time/clock-time.pipe';
import { EditTripModalComponent } from './modals/edit-trip-modal/edit-trip-modal.component';
import { ToastrModule } from 'ngx-toastr';
import { OfferedComponent } from './component/assigned-trips/offered/offered.component';
import { BrokerSettingComponent } from './component/broker-parser/broker-setting/broker-setting.component';
import { BrokerSettingListComponent } from './component/broker-parser/broker-setting-list/broker-setting-list.component';
import { AdminNemtReportComponent } from './component/superAdmin/admin-nemt-report/admin-nemt-report.component';
import { AuthTokenComponent } from './component/auth-token/auth-token.component';
import { CompaniesListComponent } from './component/companies/companies-list/companies-list.component';
import { CreateCompanyComponent } from './component/companies/create-company/create-company.component';
import { QuarterListComponent } from './component/superAdmin/quarters/quarter-list/quarter-list.component';
import { InvoiceSettingListComponent } from './component/superAdmin/invoice-settings/invoice-setting-list/invoice-setting-list.component';
import { AddressPickerComponent } from './component/shared/address-picker/address-picker.component';
import { NemtProTipsComponent } from './component/helping-material/nemt-pro-tips/nemt-pro-tips/nemt-pro-tips.component';
import { ImagesliderDirective } from './directives/image-slider/imageslider.directive';
import { SortByPipe } from './pipe/sortby-filter-pipe/sortby-filter-pipe';
import { StatisticsDetailsComponent } from './component/kpis/nemt-statistics-details/statistics-details/statistics-details.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ManifestComponent } from './component/assigned-trips/manifest/manifest.component';
import { ConvertPhoneNumberDirective } from './directives/number-directive/convert-phone-number.directive';
import { StandingOrdersV2Component } from './component/assigned-trips/standing-orders-v2/standing-orders-v2.component';
import { OWL_DATE_TIME_FORMATS, OwlDateTimeModule } from './modules/picker/src/public_api';
import { OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS } from './modules/picker/src/lib/date-time/adapter/moment-adapter/moment-date-time-adapter.class';
import { OwlMomentDateTimeModule } from './modules/picker/src/lib/date-time/adapter/moment-adapter/moment-date-time.module';
import { TimezonePickerModule } from './modules/ng2-timezone-selector/src';

import { NemtSuperProTipsComponent } from './component/superAdmin/nemt-super-tips/nemt-super-pro-tips/nemt-super-pro-tips.component';
import { CreateTipsComponent } from './component/superAdmin/create-pro-tips/create-tips/create-tips.component';
import { StandingOrderCloneModalComponent } from './modals/standing-order-clone-modal/standing-order-clone-modal.component';
import { GanttChartComponent } from './component/assigned-trips/gantt-chart/gantt-chart.component';
import { UnAuthorizationGuard } from './service/non-auth-guard/unauthorization-guard.service';
import { StandingorderDetailModalComponent } from './modals/standingorder-detail-modal/standingorder-detail-modal/standingorder-detail-modal.component';
import { VehicleInspectionComponent } from './component/reports/inspection/vehicle-inspection/vehicle-inspection.component';
import { AddVehicleInspectionComponent } from './component/reports/inspection/add-vehicle-inspection/add-vehicle-inspection.component';
import { DailyVehicleInspectionComponent } from './component/reports/inspection/daily-vehicle-inspection/daily-vehicle-inspection/daily-vehicle-inspection.component';
import { VehicleDetailModalComponent } from './component/reports/inspection/daily-vehicle-inspection/daily-vehicle-detail-modal/vehicle-detail-modal.component';
import { TrfsTemplatesComponent } from './component/billing/trfs-templates/trfs-templates.component';
import { CtcClaimedTripsComponent } from './component/assigned-trips/offered/ctc-claimed-trips/ctc-claimed-trips.component';
import { NumericSortPipe } from './pipe/numeric-sort-pipe/numeric-sort.pipe';
import { TripGenerateModalComponent } from './modals/outstanding-generate-trip-modal/trip-generate-modal/trip-generate-modal.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DriverShiftModalComponent } from './modals/driver-shift-modal/driver-shift-modal/driver-shift-modal.component';
import { DriverLoadV2Component } from './component/assigned-trips/driver-load-v2/driver-load-v2.component';
import { DriverExpensesComponent } from './component/maintenances/driver-expenses/driver-expenses.component';
import { VehicleExpensesComponent } from './component/maintenances/vehicle-expenses/vehicle-expenses.component';
import { MaintenanceDetailModalComponent } from './modals/maintenance-detail-modal/maintenance-detail-modal.component';
import { MaintenanceStatsComponent } from './component/maintenances/maintenance-stats/maintenance-stats.component';
import { FormatTitleCasePipe } from './pipe/format-titlecase.filter/format-titlecase.filter.pipe';
import { RoutingWrapperComponent } from './component/assigned-trips/outstanding/routing-wrapper/routing-wrapper.component';
import { InspectionWrapperComponent } from './component/reports/inspection/inspection-wrapper/inspection-wrapper.component';
import { PartialEditComponent } from './modals/partial-edit-modal/partial-edit.component';
import { SortByNumberPipe } from './pipe/sortby-number/sort-by-number.pipe';
import { OperationsV2Component } from './component/assigned-trips/operations-v2/operations-v2.component';
import { DispatchDriverTripsModalComponent } from './component/shared/slideouts/dispatch-driver-trips-modal/dispatch-driver-trips-modal/dispatch-driver-trips-modal.component';
import { DriverTimelinesV2Component } from './component/drivers/driver-timelines-V2/driver-timelines-v2/driver-timelines-v2.component';
import { DriverAmendmentsComponent } from './component/drivers/driver-amendments/driver-amendments/driver-amendments.component';
import { TripsMapDashboardModalComponent } from './modals/trips-map-dashboard-modal/trips-map-dashboard-modal.component';
import { TripPurposesListComponent } from './component/trip-purposes/trip-purposes-list/trip-purposes-list.component';
import { AddTripPurposesComponent } from './component/trip-purposes/trip-purposes-add/trip-purposes-add.component';
import { AddLevelOfServiceComponent } from './component/level-of-service/add-level-of-service/add-level-of-service.component';
import { LevelOfServiceComponent } from './component/level-of-service/level-of-service-list/level-of-service-list.component';
import { AddDriverAmendmentsComponent } from './component/drivers/driver-amendments/add-driver-amendments/add-driver-amendments.component';
import { AdminEarningReportComponent } from './component/superAdmin/admin-earning-report/admin-earning-report.component';
import { CompanyDriverEarningModalComponent } from './component/superAdmin/admin-earning-report/company-driver-earning-modal/company-driver-earning-modal.component';
import { DriverWrapperComponent } from './component/drivers/driver-wrapper/driver-wrapper.component';
import { DriverCredentialsComponent } from './component/drivers/driver-credentials/driver-credentials.component';
import { ServiceAreasListingComponent } from './component/service-areas/service-areas-listing/service-areas-listing.component';
import { ServiceAreasAddComponent } from './component/service-areas/service-areas-add/service-areas-add.component';
import { AddSpaceTypesComponent } from './component/level-of-service/add-space-types/add-space-types.component';
import { SpaceTypesListComponent } from './component/level-of-service/space-types-list/space-types-list.component';
import { FleetCredentialsComponent } from './component/fleet/fleet-credentials/fleet-credentials.component';
import { EquipmentListComponent } from './component/equipments/equipment-list/equipment-list.component';
import { AddEquipmentComponent } from './component/equipments/add-equipment/add-equipment.component';
import { AddPrimaryDiagnosisComponent } from './component/primary-diagnosis/add-primary-diagnosis/add-primary-diagnosis.component';
import { PrimaryDiagnosisListComponent } from './component/primary-diagnosis/primary-diagnosis-list/primary-diagnosis-list.component';
import { AddModifierCodeComponent } from './component/modifier-codes/add-modifier-code/add-modifier-code.component';
import { ModifierCodeListComponent } from './component/modifier-codes/modifier-code-list/modifier-code-list.component';
import { AddMemberWrapperModalComponent } from './component/members/add-member-wrapper-modal/add-member-wrapper-modal.component';
import { ConfigurationsComponent } from './component/corporate-user/configurations/configurations.component';
import { ConfigurationsListComponent } from './component/corporate-user/configurations-list/configurations-list.component';
import { CorporateWrapperComponent } from './component/corporate-user/corporate-wrapper/corporate-wrapper.component';
import { SmsDashboardComponent } from './component/sms/sms-dashboard/sms-dashboard.component';
import { ViolationsSetFormComponent } from './component/violations-sets/violations-set-form/violations-set-form.component';
import { ArrayFilterbykeyPipePipe } from './pipe/array-filterbykey-pipe/array-filterbykey-pipe.pipe';
import { PlannerComponent } from './component/assigned-trips/trip-planner/planner/planner.component';
import { PlannerScheduleModalComponent } from './component/assigned-trips/trip-planner/planner-schedule-modal/planner-schedule-modal.component';
import { CreateQuarterComponent } from './component/superAdmin/quarters/create-quarter/create-quarter.component';
import { BreakModalComponent } from './modals/break-modal/break-modal.component';
import { TripActivityLogComponent } from './component/assigned-trips/trip-activity-log/trip-activity-log.component';
import { PlannerScheduleLogsModalComponent } from './component/assigned-trips/trip-planner/planner-schedule-logs-modal/planner-schedule-logs-modal.component';
import { environment } from 'src/environments/environment';
import { AddonListComponent } from './component/addons/addon-list/addon-list.component';
import { AddAddonComponent } from './component/addons/add-addon/add-addon.component';
import { AddExpenseModalComponent } from './modals/add-expense-modal/add-expense-modal.component';
import { VehicleAssignModalComponent } from './modals/vehicle-assign-modal/vehicle-assign-modal.component';
import { AddAmendmentModalComponent } from './modals/add-amendment-modal/add-amendment-modal.component';
import { AdditionalNoteModalComponent } from './modals/additional-note-modal/additional-note-modal.component';
import { AdjustedTripOdomterModalComponent } from './modals/adjusted-trip-odomter-modal/adjusted-trip-odomter-modal.component';
import { AssociateImageModalComponent } from './modals/associate-image-modal/associate-image-modal.component';
import { BillerNoteModalComponent } from './modals/biller-note-modal/biller-note-modal.component';
import { SignatureModalComponent } from './modals/signature-modal/signature-modal.component';
import { AccidentalReportListComponent } from './component/reports/accidental-report/accidental-report-list/accidental-report-list.component';
import { DriverGrievanceComponent } from './component/reports/driver-grievance/driver-grievance/driver-grievance.component';
import { DriverScoreComponent } from './component/reports/driver-score/driver-score.component';
import { TripDetailsComponent } from './modals/trip-details-modal/trip-details.component';
import { AdjustmentComponent } from './component/billing/adjustment/adjustment.component';
import { ManualLineTripComponent } from './component/assigned-trips/manual-line-trip/manual-line-trip.component';
import { GoogleMapsInitializer } from './service/googlemap-key-service/google-maps-initializer.service';
import { TripReportsComponent } from './component/reports/trip-reports/trip-reports.component';
import { DriverLoadActionsDropdownComponent } from './component/shared/driver-load-actions-dropdown/driver-load-actions-dropdown.component';
import { BillingActionsDropdownComponent } from './component/shared/billing-actions-dropdown/billing-actions-dropdown.component';
import { EdiReportsComponent } from './component/billing/edi-parser/edi-reports/edi-reports.component';
import { AddEdiReportComponent } from './component/billing/edi-parser/add-edi-report/add-edi-report.component';
import { EdiReportModalComponent } from './modals/edi-report-modal/edi-report-modal.component';
import { DriverStatisticsComponent } from './component/reports/driver-statistics/driver-statistics.component';
import { ApplyIncentiveModalComponent } from './modals/apply-incentive-modal/apply-incentive-modal.component';
import { OutboundingComponent } from './component/reports/outbounding/outbounding.component';
import { MemberStatusModalComponent } from './modals/member-status-modal/member-status-modal.component';
import { MapperModalComponent } from './modals/mapper-modal/mapper-modal.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NonNegativeDirective } from './directives/non-negative-directive/non-negative.directive';
import { TooltipDirective } from './directives/tooltip/tooltip.directive';
import { AnnouncementListComponent } from './component/extras/announcement/announcement-list/announcement-list.component';
import { AddAnnouncementComponent } from './component/extras/announcement/add-announcement/add-announcement.component';
import { FleetEquipmentsComponent } from './component/fleet/capacity-planning/fleet-equipments.component';
import { FilterByMultipleKeysPipe } from './pipe/filterByMultipleKeys/filter-by-multiple-keys.pipe';
import { TooltipComponent } from './component/shared/tooltip/tooltip.component';
import { LateForecastComponent } from './component/assigned-trips/late-forecast/late-forecast.component';
import { MapViewComponent } from './component/superAdmin/map-view/map-view.component';
import { FarmoutModalComponent } from './modals/farmout-modal/farmout-modal.component';
import { FarmoutTripsComponent } from './component/assigned-trips/farmout/farmout-trips/farmout-trips.component';

import { MfbComponent } from './component/miles-for-buck/mfb/mfb-list/mfb.component';
import { AddMfbComponent } from './component/miles-for-buck/mfb/add-mfb/add-mfb.component';
import { MfbDashboardComponent } from './component/miles-for-buck/mfb/mfb-dashboard/mfb-dashboard.component';
import { AssistWrapperComponent } from './component/miles-for-buck/assist-wrapper/assist-wrapper.component';
import { AddAssistComponent } from './component/miles-for-buck/assist/add-assist/add-assist.component';
import { AssistListComponent } from './component/miles-for-buck/assist/assist-list/assist-list.component';
import { DashboardWrapperComponent } from './component/miles-for-buck/dashboard-wrapper/dashboard-wrapper.component';
import { AssistDashboardComponent } from './component/miles-for-buck/assist/assist-dashboard/assist-dashboard.component';
import { DriverTripsModalComponent } from './modals/driver-trips-modal/driver-trips-modal.component';
import { HolidaysListComponent } from './component/extras/holidays/holidays-list/holidays-list.component';
import { AddHolidayComponent } from './component/extras/holidays/add-holiday/add-holiday.component';
import { ChecklistModalComponent } from './modals/checklist-modal/checklist-modal.component';
import { ChecklistComponent } from './component/spaceType-checklist/checklist/checklist.component';
import { AddChecklistComponent } from './component/spaceType-checklist/add-checklist/add-checklist.component';
import { PlannerTemplateSaveModalComponent } from './component/assigned-trips/trip-planner/planner-template-save-modal/planner-template-save-modal.component';
import { DriverLoadWrapperComponent } from './component/assigned-trips/driver-load-wrapper/driver-load-wrapper.component';
import { PlannerLoadWrapperComponent } from './component/assigned-trips/trip-planner/planner-load-wrapper/planner-load-wrapper.component';
import { PlannerMapperAddComponent } from './component/assigned-trips/trip-planner/planner-mapper/planner-mapper-add/planner-mapper-add.component';
import { PlannerMapperListComponent } from './component/assigned-trips/trip-planner/planner-mapper/planner-template-list/planner-mapper-list.component';
import { PlannerTemplateListComponent } from './component/assigned-trips/trip-planner/planner-template/planner-template-list/planner-template-list.component';
import { PlannerTemplateAddComponent } from './component/assigned-trips/trip-planner/planner-template/planner-template-add/planner-template-add.component';
import { NemtReportWrapperComponent } from './component/kpis/nemt-report-wrapper/nemt-report-wrapper.component';
import { NemtReportRevenueComponent } from './component/kpis/nemt-report-revenue/nemt-report-revenue.component';
import { CloneModalComponent } from './modals/clone-modal/clone-modal.component';
import { FarmoutWrapperComponent } from './component/assigned-trips/farmout/farmout-wrapper/farmout-wrapper.component';
import { FarmoutReceiptComponent } from './component/assigned-trips/farmout/farmout-receipt/farmout-receipt.component';
import { FarmoutReceiptModalComponent } from './component/assigned-trips/farmout/farmout-receipt-modal/farmout-receipt-modal.component';
import { FarmoutSavingsComponent } from './component/assigned-trips/farmout/farmout-savings/farmout-savings.component';
import { OdometerModalComponent } from './modals/odometer-modal/odometer-modal.component';
import { PlaygroundComponent } from './component/assigned-trips/playground/playground.component';
import { RouteTrackerComponent } from './modals/route-tracker/route-tracker.component';
import { DriverReportModalComponent } from './component/kpis/driver-report-modal/driver-report-modal.component';
import { WillcallActivationModalComponent } from './modals/willcall-activation-modal/willcall-activation-modal.component';
import { TruncatePipe } from './pipe/truncate-pipe/truncate.pipe';
import { PlannerBucketsComponent } from './component/assigned-trips/trip-planner/planner-buckets/planner-buckets.component';
import { DriverTrackingComponent } from './component/drivers/driver-tracking/driver-tracking.component';
import { GanttChartV2Component } from './component/assigned-trips/gantt-chart-v2/gantt-chart-v2.component';
import { PlannerMapperWrapperComponent } from './component/assigned-trips/trip-planner/planner-mapper/planner-mapper-wrapper/planner-mapper-wrapper.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { StandingOrderActionsDropdownComponent } from './component/shared/standing-order-actions-dropdown/standing-order-actions-dropdown.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DriverLoadV3Component } from './component/assigned-trips/driver-load-v3/driver-load-v3.component';
import { PlannerDriverMapperListComponent } from './component/assigned-trips/trip-planner/planner-mapper/planner-driver-mapper-list/planner-driver-mapper-list.component';
import { PlannerDriverMapperAddComponent } from './component/assigned-trips/trip-planner/planner-mapper/planner-driver-mapper-add/planner-driver-mapper-add.component';
import { DriverShiftOverrideComponent } from './component/drivers/shift-override/driver-shift-override/driver-shift-override.component';
import { DriverShiftOverrideListComponent } from './component/drivers/shift-override/driver-shift-override-list/driver-shift-override-list.component';
import { DriverListActionsDropdownComponent } from './component/shared/driver-list-actions-dropdown/driver-list-actions-dropdown.component';
import { PlannerBucketsWrapperComponent } from './component/assigned-trips/trip-planner/planner-buckets-wrapper/planner-buckets-wrapper.component';
import { BucketWrapperComponent } from './component/assigned-trips/bucket-wrapper/bucket-wrapper.component';
import { RoutePlannerComponent } from './component/assigned-trips/trip-planner/route-planner/route-planner.component';
import { ChartComponent } from './component/shared/chart/chart.component';
import { StatisticsModalComponent } from './modals/statistics-modal/statistics-modal.component';
import { MemberAutocompleteDirective } from './directives/member-autocomplete/member-autocomplete.directive';
import { ReportConfigurationModalComponent } from './modals/report-configuration-modal/report-configuration-modal.component';
import { MessageNotificationModalComponent } from './modals/message-notification-modal/message-notification-modal.component';
import { TableColumnSortDirective } from './directives/table-column-sort/table-column-sort.directive';
import { SweetSelectComponent } from './component/shared/sweet-select/sweet-select.component';
import { DriverEarningsComponent } from './component/reports/driver-earnings/driver-earnings.component';
import { MemberTripsModalComponent } from './modals/member-trips-modal/member-trips-modal.component';
import { PushToTalkWrapperComponent } from './component/push-to-talk/push-to-talk-wrapper/push-to-talk-wrapper.component';
import { AllRecordingsComponent } from './component/push-to-talk/all-recordings/all-recordings.component';
import { PushToTalkComponent } from './component/push-to-talk/push-to-talk/push-to-talk.component';
import { CreateGroupChatModalComponent } from './modals/create-group-chat-modal/create-group-chat-modal.component';
import { ViewersModalComponent } from './modals/viewers-modal/viewers-modal.component';
import { CustomTooltipDirective } from './directives/custom-tooltip/custom-tooltip.directive';
import { CallModalComponent } from './modals/call-modal/call-modal.component';
import { CallNotificationModalComponent } from './modals/call-notification-modal/call-notification-modal.component';
import { ResetPasswordComponent } from './component/reset-password/reset-password.component';
import { PossibilityAssignModalComponent } from './modals/possibility-assign-modal/possibility-assign-modal.component';
import { LyftDetailsModalComponent } from './modals/lyft-details-modal/lyft-details-modal.component';
import { TripSheetComponent } from './component/assigned-trips/trip-sheet/trip-sheet.component';
import { TripSheetV2Component } from './component/assigned-trips/trip-sheet-v2/trip-sheet-v2.component';
import { AiAssistantConversationModalComponent } from './modals/ai-assistant-conversation-modal/ai-assistant-conversation-modal.component';
import { NewTripImportModalComponent } from './modals/new-trip-import-modal/new-trip-import-modal.component';
import { NewTripExtractorService } from './service/ai-assistant-service/new-trip-extractor.service';
import { AutoLogoutService } from './service/auto-logout-service/auto-logout.service';
import { AddCredentialedDriverComponent } from './component/credentialing/drivers/add-credentialed-driver/add-credentialed-driver.component';
import { CredentialedDriversListComponent } from './component/credentialing/drivers/credentialed-drivers-list/credentialed-drivers-list.component';
import { DriverLoadV4Component } from './component/assigned-trips/driver-load-v4/driver-load-v4.component';
import { RouteMonitoringComponent } from './component/assigned-trips/transit/route-monitoring/route-monitoring.component';
import { RouteDetailsModalComponent } from './component/assigned-trips/transit/route-details-modal/route-details-modal.component';
import { AddRouteModalComponent } from './component/assigned-trips/transit/add-route-modal/add-route-modal.component';
import { AddRouteStandingOrdersComponent } from './component/assigned-trips/transit/route-standing-orders/add-route-standing-orders/add-route-standing-orders.component';
import { RouteStandingOrdersComponent } from './component/assigned-trips/transit/route-standing-orders/route-standing-orders/route-standing-orders.component';
import { AssignTripModalComponent } from './component/assigned-trips/transit/assign-trip-modal/assign-trip-modal.component';
import { CancelRouteModalComponent } from './component/assigned-trips/transit/cancel-route-modal/cancel-route-modal.component';
import { TutorialListComponent } from './component/tutorials/tutorial-list/tutorial-list.component';
import { NewTaxiRideComponent } from './component/taxi/new-taxi-ride/new-taxi-ride.component';
import { TaxiRideEditModalComponent } from './component/taxi/taxi-ride-edit-modal/taxi-ride-edit-modal.component';
import { MarketplaceComponent } from './component/assigned-trips/marketplace/marketplace.component';
import { BulkCallReviewModalComponent } from './modals/bulk-call-review-modal/bulk-call-review-modal/bulk-call-review-modal.component';
import { FleetioIframeComponent } from './component/fleet/fleetio-iframe/fleetio-iframe.component';
import { PlannerV2Component } from './component/assigned-trips/planner-v2/planner-v2.component';
import { BusinessReportsComponent } from './component/reports/business-reports/business-reports.component';
import { BrLoadingComponent } from './component/reports/business-reports/shared/loading/loading.component';
import { BrReportCardComponent } from './component/reports/business-reports/shared/report-card/report-card.component';
import { BrTogglePillsComponent } from './component/reports/business-reports/shared/toggle-pills/toggle-pills.component';
import { BrChartTypeToggleComponent } from './component/reports/business-reports/shared/chart-type-toggle/chart-type-toggle.component';
import { BrChartTypeIconComponent } from './component/reports/business-reports/shared/chart-type-icon/chart-type-icon.component';
import { BrChartGridComponent } from './component/reports/business-reports/shared/chart-grid/chart-grid.component';
import { BrEntityAvatarCellComponent } from './component/reports/business-reports/shared/entity-avatar-cell/entity-avatar-cell.component';
import { BrDataTableComponent } from './component/reports/business-reports/shared/data-table/data-table.component';
import { BrBarChartComponent } from './component/reports/business-reports/shared/bar-chart/bar-chart.component';
import { BrDonutChartComponent } from './component/reports/business-reports/shared/donut-chart/donut-chart.component';
import { BrStackedBarChartComponent } from './component/reports/business-reports/shared/stacked-bar-chart/stacked-bar-chart.component';
import { BrOverviewTabComponent } from './component/reports/business-reports/tabs/overview-tab/overview-tab.component';
import { BrTripsTabComponent } from './component/reports/business-reports/tabs/trips-tab/trips-tab.component';
import { BrRevenueTabComponent } from './component/reports/business-reports/tabs/revenue-tab/revenue-tab.component';
import { BrBreakdownTabComponent } from './component/reports/business-reports/tabs/breakdown-tab/breakdown-tab.component';
import { BrBreakdownSectionComponent } from './component/reports/business-reports/tabs/breakdown-tab/breakdown-section/breakdown-section.component';
import { BrDriverDigestTabComponent } from './component/reports/business-reports/tabs/driver-digest-tab/driver-digest-tab.component';
import { BrTimelinessTabComponent } from './component/reports/business-reports/tabs/timeliness-tab/timeliness-tab.component';
import { AddCompanyAccountModalComponent } from './modals/add-company-account-modal/add-company-account-modal.component';
import { StaffTimelinesComponent } from './component/staffs/timelines/staff-timelines/staff-timelines.component';
import { StaffTimelinesDashboardComponent } from './component/staffs/timelines/staff-timelines-dashboard/staff-timelines-dashboard.component';
import { StaffShiftOverrideListComponent } from './component/staffs/shift-override/staff-shift-override-list/staff-shift-override-list.component';
import { AddStaffShiftOverrideComponent } from './component/staffs/shift-override/add-staff-shift-override/add-staff-shift-override.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'red',
  bgsOpacity: 0.5,
  bgsPosition: 'bottom-right',
  bgsSize: 80,
  bgsType: 'ball-spin-clockwise',
  blur: 0,
  fgsColor: '#727cf5',
  fgsPosition: 'center-center',
  fgsSize: 0,
  fgsType: 'ball-spin',
  gap: 24,
  logoPosition: 'center-center',
  logoSize: 150,
  logoUrl: '',
  masterLoaderId: 'master',
  overlayBorderRadius: '0',
  overlayColor: '#ffffff',
  pbColor: '#727cf5',
  pbDirection: 'ltr',
  pbThickness: 3,
  hasProgressBar: true,
  text: '',
  textColor: '#FFFFFF',
  textPosition: 'center-center',
};

export const MY_MOMENT_FORMATS = {
  fullPickerInput: 'MM/DD/YYYY HHmm',
  parseInput: 'l LT',
  datePickerInput: 'l',
  timePickerInput: 'HH:mm',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  swipeEasing: true,
  minScrollbarLength: 20
};
@NgModule({
  declarations: [
    NonNegativeDirective,
    TooltipDirective,
    AppComponent,
    HeaderComponent,
    StaffAttendanceComponent,
    SignInComponent,
    ForgotPasswordComponent,
    RangePipe,
    FilterPipe,
    FilterByKeyPipe,
    DispatchDashboardComponent,
    StaffMainComponent,
    StaffsCreateComponent,
    EditUserProfileComponent,
    AutocompleteComponent,
    // TripsHistoryComponent,
    DriverListComponent,
    RolePipe,
    AccountStatusPipe,
    CreateDriverComponent,
    DriverProfileDashboardComponent,
    ImageModalComponent,
    CamelCasePipe,
    CorporateuserComponent,
    CorporateAddUserComponent,
    FleetListComponent,
    CreateFleetComponent,
    DriverDistributionsComponent,
    DriverDistributionsCreateComponent,
    DriverAlertComponent,
    HelpingMaterialListComponent,
    UrlSafePipe,
    ParseTripsComponent,
    NewTripComponent,
    AutocompleteComponent,
    DispatchDashboardComponent,
    UnassignedComponent,
    VerifiedTripLogsComponent,
    CustomPlaceDirective,
    GooglePlaceDirective,
    NemtStatisticsComponent,
    NemtReportComponent,
    DynamicFareListComponent,
    DynamicFareAddComponent,
    EarningsComponent,
    TripDetailsComponent,
    AdjustmentComponent,
    TripFilterPipe,
    TripAssignModalComponent,
    PossibilityAssignModalComponent,
    TimeFormatDirective,
    CompanyNoteModalComponent,
    CancelTripModalComponent,
    // ConfirmModalComponent,
    TimePipe,
    TripDetailDialogComponent,
    BillerNoteModalComponent,
    CommonAlertComponent,
    DriverBreakdownComponent,
    SweepTripsModalComponent,
    DatePipe,
    NotificationDetailsComponent,
    ComplianceNotificationsComponent,
    // AccidnetsListComponent,
    // AddAccidentComponent,
    HelpingMaterialPdfComponent,
    // AccidentDetailInTailwindFormComponent,
    LogsComponent,
    MemberListComponent,
    CreateMemberComponent,
    OutstandingComponent,
    DriverInvoicesComponent,
    DirtRoadComponent,
    DriverTimelinesComponent,
    TripDetailModelComponent,
    OutstandingTripsModalComponent,
    // TripAdjustmentComponent,
    // CompletedCancelModalComponent,
    AdditionalNoteModalComponent,
    ZDatesComponent,
    SideNavComponent,
    NotificationsSlideoutComponent,
    DispatchInprogressTripsSlideoutComponent,
    SortByDatePipe,
    FormatTitleCasePipe,
    DriverEarningModalComponent,
    AddExpenseModalComponent,
    OutsideClickDirective,
    BrokerDropdownComponent,
    TripActionsDropdownComponent,
    ClockTimePipe,
    SortByPipe,
    EditTripModalComponent,
    AdjustedTripOdomterModalComponent,
    OfferedComponent,
    BrokerSettingComponent,
    BrokerSettingListComponent,
    AuthTokenComponent,
    AdminNemtReportComponent,
    CompaniesListComponent,
    CreateCompanyComponent,
    QuarterListComponent,
    InvoiceSettingListComponent,
    AddressPickerComponent,
    NemtProTipsComponent,
    ImagesliderDirective,
    StatisticsDetailsComponent,
    ManifestComponent,
    ConvertPhoneNumberDirective,
    StandingOrdersV2Component,
    NemtSuperProTipsComponent,
    CreateTipsComponent,
    StandingOrderCloneModalComponent,
    GanttChartComponent,
    VehicleInspectionComponent,
    AddVehicleInspectionComponent,
    StandingorderDetailModalComponent,
    SignatureModalComponent,
    DailyVehicleInspectionComponent,
    VehicleDetailModalComponent,
    TrfsTemplatesComponent,
    CtcClaimedTripsComponent,
    NumericSortPipe,
    TripGenerateModalComponent,
    ManualLineTripComponent,
    DriverShiftModalComponent,
    AccidentalReportListComponent,
    DriverExpensesComponent,
    VehicleExpensesComponent,
    MaintenanceDetailModalComponent,
    MaintenanceStatsComponent,
    AssociateImageModalComponent,
    DriverLoadV2Component,
    DriverScoreComponent,
    DriverGrievanceComponent,
    RoutingWrapperComponent,
    InspectionWrapperComponent,
    PartialEditComponent,
    SortByNumberPipe,
    OperationsV2Component,
    DispatchDriverTripsModalComponent,
    DriverTimelinesV2Component,
    DriverAmendmentsComponent,
    AddAmendmentModalComponent,
    TripsMapDashboardModalComponent,
    TripPurposesListComponent,
    AddTripPurposesComponent,
    AddLevelOfServiceComponent,
    LevelOfServiceComponent,
    AddDriverAmendmentsComponent,
    AdminEarningReportComponent,
    CompanyDriverEarningModalComponent,
    DriverWrapperComponent,
    DriverCredentialsComponent,
    ServiceAreasListingComponent,
    ServiceAreasAddComponent,
    AddSpaceTypesComponent,
    SpaceTypesListComponent,
    FleetCredentialsComponent,
    EquipmentListComponent,
    AddEquipmentComponent,
    AddPrimaryDiagnosisComponent,
    PrimaryDiagnosisListComponent,
    AddModifierCodeComponent,
    ModifierCodeListComponent,
    AddMemberWrapperModalComponent,
    ConfigurationsComponent,
    ConfigurationsListComponent,
    CorporateWrapperComponent,
    SmsDashboardComponent,
    ViolationsSetFormComponent,
    VehicleAssignModalComponent,
    ArrayFilterbykeyPipePipe,
    PlannerComponent,
    PlannerScheduleModalComponent,
    PlannerScheduleLogsModalComponent,
    CreateQuarterComponent,
    BreakModalComponent,
    TripActivityLogComponent,
    PlannerTemplateListComponent,
    PlannerTemplateAddComponent,
    AddonListComponent,
    AddAddonComponent,
    TripReportsComponent,
    DriverLoadActionsDropdownComponent,
    BillingActionsDropdownComponent,
    EdiReportsComponent,
    AddEdiReportComponent,
    EdiReportModalComponent,
    DriverStatisticsComponent,
    ApplyIncentiveModalComponent,
    OutboundingComponent,
    MemberStatusModalComponent,
    MapperModalComponent,
    AnnouncementListComponent,
    AddAnnouncementComponent,
    FleetEquipmentsComponent,
    FilterByMultipleKeysPipe,
    TooltipComponent,
    LateForecastComponent,
    MapViewComponent,
    FarmoutModalComponent,
    FarmoutTripsComponent,
    MfbComponent,
    AddMfbComponent,
    MfbDashboardComponent,
    AssistWrapperComponent,
    AddAssistComponent,
    AssistListComponent,
    DashboardWrapperComponent,
    AssistDashboardComponent,
    DriverTripsModalComponent,
    HolidaysListComponent,
    AddHolidayComponent,
    ChecklistModalComponent,
    ChecklistComponent,
    AddChecklistComponent,
    PlannerTemplateSaveModalComponent,
    DriverLoadWrapperComponent,
    PlannerLoadWrapperComponent,
    PlannerMapperAddComponent,
    PlannerMapperListComponent,
    NemtReportWrapperComponent,
    NemtReportRevenueComponent,
    CloneModalComponent,
    FarmoutWrapperComponent,
    FarmoutReceiptComponent,
    FarmoutReceiptModalComponent,
    FarmoutSavingsComponent,
    OdometerModalComponent,
    PlaygroundComponent,
    RouteTrackerComponent,
    DriverReportModalComponent,
    WillcallActivationModalComponent,
    TruncatePipe,
    PlannerBucketsComponent,
    DriverTrackingComponent,
    GanttChartV2Component,
    StandingOrderActionsDropdownComponent,
    PlannerMapperWrapperComponent,
    DriverLoadV3Component,
    PlannerDriverMapperListComponent,
    PlannerDriverMapperAddComponent,
    DriverShiftOverrideComponent,
    DriverShiftOverrideListComponent,
    DriverListActionsDropdownComponent,
    PlannerBucketsWrapperComponent,
    BucketWrapperComponent,
    RoutePlannerComponent,
    ChartComponent,
    StatisticsModalComponent,
    MemberAutocompleteDirective,
    ReportConfigurationModalComponent,
    MessageNotificationModalComponent,
    SweetSelectComponent,
    TableColumnSortDirective,
    DriverEarningsComponent,
    MemberTripsModalComponent,
    PushToTalkWrapperComponent,
    PushToTalkComponent,
    AllRecordingsComponent,
    CreateGroupChatModalComponent,
    ViewersModalComponent,
    CustomTooltipDirective,
    CallNotificationModalComponent,
    CallModalComponent,
    ResetPasswordComponent,
    LyftDetailsModalComponent,
    TripSheetComponent,
    TripSheetV2Component,
    AiAssistantConversationModalComponent,
    NewTripImportModalComponent,
    AddCredentialedDriverComponent,
    CredentialedDriversListComponent,
    DriverLoadV4Component,
    RouteMonitoringComponent,
    RouteDetailsModalComponent,
    AddRouteModalComponent,
    RouteStandingOrdersComponent,
    AddRouteStandingOrdersComponent,
    AssignTripModalComponent,
    CancelRouteModalComponent,
    TutorialListComponent,
    NewTaxiRideComponent,
    TaxiRideEditModalComponent,
    MarketplaceComponent,
    BulkCallReviewModalComponent,
    PlannerV2Component,
    FleetioIframeComponent,

    BusinessReportsComponent,
    BrLoadingComponent,
    BrReportCardComponent,
    BrTogglePillsComponent,
    BrChartTypeToggleComponent,
    BrChartTypeIconComponent,
    BrChartGridComponent,
    BrEntityAvatarCellComponent,
    BrDataTableComponent,
    BrBarChartComponent,
    BrDonutChartComponent,
    BrStackedBarChartComponent,
    BrOverviewTabComponent,
    BrTripsTabComponent,
    BrRevenueTabComponent,
    BrBreakdownTabComponent,
    BrBreakdownSectionComponent,
    BrDriverDigestTabComponent,
    BrTimelinessTabComponent,
    AddCompanyAccountModalComponent,
    StaffTimelinesComponent,
    StaffTimelinesDashboardComponent,
    StaffShiftOverrideListComponent,
    AddStaffShiftOverrideComponent
  ],
  entryComponents: [TooltipComponent, SweetSelectComponent],


  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SignaturePadModule,
    ReactiveFormsModule,
    TimeagoModule.forRoot(),
    HttpClientModule, // import HttpClientModule
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig), // import NgxUiLoaderModule
    NgxUiLoaderHttpModule.forRoot({
      exclude: ['http://provider.qalbs.com/api/assigns/dashboard', 'http://provider.qalbs.com/api/notifications', 'http://provider.qalbs.com/api/assigns/corporate',
        'http://provider.qalbs.com/api/users/me', 'http://provider.qalbs.com/api/drivers/nearby'],
      showForeground: true
    }),
    CircleTimerModule,
    AgmCoreModule.forRoot({
      apiKey: "",
      libraries: ['places']
    }),
    SocketIoModule,
    TimezonePickerModule,
    AgmDirectionModule,
    BrowserAnimationsModule,
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    PerfectScrollbarModule,
    AgmOverlays,
    OwlModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-left',
      preventDuplicates: true,
      progressBar: true
    }),
    NgSelectModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxPaginationModule,
    ScrollingModule,
    DragDropModule,
    ChartsModule,

  ],

  providers: [
    {
      provide: APP_INITIALIZER,
      deps: [LAZY_MAPS_API_CONFIG, GoogleMapsInitializer],
      multi: true,
      useFactory: (config: LazyMapsAPILoaderConfigLiteral, initializer: GoogleMapsInitializer) => () => initializer.initialize(config),
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    { provide: AuthorizationGuard, useClass: AuthorizationGuard },
    { provide: UnAuthorizationGuard, useClass: UnAuthorizationGuard },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
    { provide: OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    DatePipe,
    FilterByMultipleKeysPipe,
    FormatTitleCasePipe,
    MySocketWrapper,
    SocketService,
    CamelCasePipe,
    ThemeService,
    NewTripExtractorService,
    AutoLogoutService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
